<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <div
    *ngIf="database"
    class="grid">
    <div class="col-12">
      <p-card>
        <div class="p-fluid">
          <div class="field">
            <label class="font-medium required-field">Название</label>
            <crm-input-text
              [(value)]="database.name"
              [isError]="$any(errors?.name)"
              [placeholder]="(form$ | async)?.data?.isWelcomeSystem ? 'Любое название базы 1С' : ''"></crm-input-text>
            <small
              *ngIf="errors?.name"
              class="p-error">
              {{ errors.name | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium required-field">Сервер</label>
            <crm-input-text
              [(value)]="database.host"
              [isError]="$any(errors?.host)"
              [placeholder]="
                (form$ | async)?.data?.isWelcomeSystem ? 'Адрес сервера с опубликованной базой' : ''
              "></crm-input-text>
            <small
              *ngIf="errors?.host"
              class="p-error">
              {{ errors.host | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium required-field">БД</label>
            <crm-input-text
              [(value)]="database.database"
              [isError]="$any(errors?.database)"
              [placeholder]="
                (form$ | async)?.data?.isWelcomeSystem ? 'Имя опубликованной базы данных на сервере' : ''
              "></crm-input-text>
            <small
              *ngIf="errors?.database"
              class="p-error">
              {{ errors.database | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium required-field">Логин</label>
            <crm-input-text
              [(value)]="database.login"
              [isError]="$any(errors?.login)"
              [placeholder]="
                (form$ | async)?.data?.isWelcomeSystem ? 'Логин из поля 1С \'Имя (для входа)\'' : ''
              "></crm-input-text>
            <small
              *ngIf="errors?.login"
              class="p-error">
              {{ errors.login | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium required-field">Пароль</label>
            <div class="p-inputgroup">
              <input
                type="password"
                pPassword
                [feedback]="false"
                [(ngModel)]="database.password"
                [ngClass]="{ 'ng-invalid ng-dirty': errors?.password }"
                autocomplete="new-password"
                [showPassword]="showPassword"
                [placeholder]="(form$ | async)?.data?.isWelcomeSystem ? 'Пароль из поля \'Имя (для входа)\'' : ''" />
              <crm-button
                type="button"
                icon="pi {{ showPassword ? 'pi-eye-slash' : 'pi-eye' }}"
                styleClass="p-button-secondary"
                (onClick)="showPassword = !showPassword"></crm-button>
            </div>
            <small
              *ngIf="errors?.password"
              class="p-error">
              {{ errors.password | join }}
            </small>
          </div>

          <div class="field-checkbox">
            <p-checkbox
              [(ngModel)]="database.secure"
              [binary]="true"
              inputId="secure"></p-checkbox>
            <label [for]="'secure'">Использовать HTTPS</label>
          </div>

          <div class="field-checkbox">
            <p-checkbox
              [(ngModel)]="database.disabled"
              [binary]="true"
              inputId="disabled"></p-checkbox>
            <label [for]="'disabled'">Отключить от обмена</label>
          </div>
        </div>

        <div class="flex flex-wrap justify-content-center gap-2">
          <crm-button
            *ngIf="canWriteCompanyErp1C"
            label="Проверить подключение"
            [styleClass]="'p-button-text p-button-secondary' + (connection ? 'p-button-success' : 'p-button-danger')"
            [icon]="connection === true ? 'pi pi-check' : connection === false ? 'pi pi-times-circle' : ''"
            [loading]="connectionLoading"
            iconPos="right"
            (onClick)="testConnection()"></crm-button>

          <crm-button
            type="button"
            label="Скачать расширение"
            icon="pi pi-file"
            styleClass="p-button-success p-button-text"
            [loading]="loadingDownload"
            (onClick)="downloadExtension()"></crm-button>

          <crm-button
            *ngIf="isDevConsoleAvailable && (form$ | async)?.isEdit"
            type="button"
            label="Консоль разработчика"
            icon="pi pi-code"
            styleClass="p-button-warning p-button-text"
            (onClick)="openConsoleModal()"></crm-button>
        </div>
      </p-card>
    </div>
  </div>

  <div
    *ngIf="(form$ | async)?.canWrite"
    class="mt-3">
    <div class="flex flex-wrap justify-content-between">
      <crm-button
        [label]="saveButtonLabel"
        styleClass="p-button-success"
        (onClick)="saveDatabase()"></crm-button>
      <crm-button
        *ngIf="(form$ | async)?.isShowDelete"
        label="Удалить"
        styleClass="p-button-danger p-button-text"
        (onClick)="deleteDatabase()"></crm-button>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
